import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Drawer from '@/components/Modals/Drawer';
import { IScenario } from '@/types';
import ScenarioForm from './ScenarioForm';

interface DrawerProps {
  scenario: IScenario;
}

const ScenarioDrawer = NiceModal.create(({ scenario }: DrawerProps) => {
  const modal = useModal('scenario-drawer');

  return (
    <Drawer modal={modal} title="Call Scenarios">
      <ScenarioForm scenario={scenario} onClose={() => modal.hide()} />
    </Drawer>
  );
});

export default ScenarioDrawer;
